import Vue from 'vue';
import Vuex from 'vuex';
import auth from './modules/auth-module';
import settings from './modules/settings-module';
import users from './modules/user-module';
import contacts from './modules/contacts-module';
import patientStory from './modules/patient-story-module';
import pages from './modules/pages-module';
import publications from './modules/publications-module';
import activityReports from './modules/activity-reports-module';
import awards from './modules/awards-module';
import articles from './modules/articles-module';
import uploadImage from './modules/upload-image-module';
import metatags from './modules/metatags-module';
import popupBanners from './modules/popup-banner-module';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {},

  mutations: {},

  actions: {},

  modules: {
    auth,
    settings,
    users,
    contacts,
    patientStory,
    pages,
    publications,
    activityReports,
    awards,
    articles,
    uploadImage,
    metatags,
    popupBanners,
  },
});
